// extracted by mini-css-extract-plugin
export default {"link":"zM-z","disabled":"AM-z"};